import { Truck, ShieldCheck, Boxes, Wallet, Sparkles, Phone } from "lucide-react";

const items = [
  {
    icon: Wallet,
    title: "Prețuri En-Gross",
    desc: "Tarife optimizate pentru volum. Negociem direct cu producătorii.",
    span: "lg:col-span-3",
  },
  {
    icon: Truck,
    title: "Livrare Rapidă",
    desc: "Logistică proprie, promptitudine garantată în toată țara.",
    span: "lg:col-span-3",
  },
  {
    icon: ShieldCheck,
    title: "Calitate Premium",
    desc: "Selecție riguroasă. Toate produsele cu certificate și termene optime.",
    span: "lg:col-span-2",
  },
  {
    icon: Boxes,
    title: "Stocuri Constante",
    desc: "Fără întreruperi. Aprovizionare continuă pentru afacerea ta.",
    span: "lg:col-span-2",
  },
  {
    icon: Sparkles,
    title: "Gama Variată",
    desc: "Peste 140 produse: marinate, conserve, dulciuri, vinuri.",
    span: "lg:col-span-2",
  },
  {
    icon: Phone,
    title: "Suport Dedicat",
    desc: "Un reprezentant personal pentru fiecare cont B2B activ.",
    span: "lg:col-span-6",
  },
];

export const WhyUs = () => (
  <section
    id="beneficii"
    data-testid="why-us-section"
    className="relative py-20 sm:py-28 bg-[#080706]"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <div className="max-w-3xl mb-16">
        <p className="text-xs font-semibold tracking-[0.32em] uppercase text-[#C8A97E] mb-6">
          — De Ce Să Ne Alegi
        </p>
        <h2 className="font-[Playfair_Display] text-[#FDF8F5] text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.08] tracking-tight">
          Beneficii reale pentru
          <br />
          <em className="italic text-[#C8A97E]">partenerii</em> noștri.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-5">
        {items.map(({ icon: Icon, title, desc, span }) => (
          <div
            key={title}
            data-testid={`why-item-${title}`}
            className={`group flex flex-col justify-between bg-[#0F0D0B] border border-[#2A2522] hover:border-[#C8A97E]/70 transition-all duration-500 p-8 min-h-[220px] ${span}`}
          >
            <Icon
              className="text-[#C8A97E] group-hover:scale-110 transition-transform duration-500"
              size={36}
              strokeWidth={1.1}
            />
            <div className="mt-8">
              <h3 className="font-[Playfair_Display] text-[#FDF8F5] text-2xl tracking-tight mb-2">
                {title}
              </h3>
              <p className="text-[#A8A29E] text-sm font-light leading-relaxed">{desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
